// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import FormField from "../FormField";
import FormSelect from "components/FormSelect";

function UserInfo({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { email, password, repeatPassword, firstname, lastname, role } = formField;
  const {
    email: emailV,
    password: passwordV,
    repeatPassword: repeatPasswordV,
    firstname: firstnameV,
    lastname: lastnameV,
    role: roleV,
  } = values;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">New User</MDTypography>
        <MDTypography variant="button" color="text">
          Mandatory informations
        </MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={firstname.type}
              label={firstname.label}
              name={firstname.name}
              value={values.firstname}
              placeholder={firstname.placeholder}
              error={errors.firstname && touched.firstname}
              success={firstnameV.length > 0 && !errors.firstname}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={lastname.type}
              label={lastname.label}
              name={lastname.name}
              value={values.lastname}
              placeholder={lastname.placeholder}
              error={errors.lastname && touched.lastname}
              success={lastnameV.length > 0 && !errors.lastname}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={email.type}
              label={email.label}
              name={email.name}
              value={emailV}
              placeholder={email.placeholder}
              error={errors.email && touched.email}
              success={emailV.length > 0 && !errors.email}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDTypography variant="caption" color="text">
              Role
            </MDTypography>
            <FormSelect
              label={role.label}
              name={role.name}
              value={roleV}
              options={role.options}
              error={errors.role && touched.role}
              success={roleV.length > 0 && !errors.role}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={password.type}
              label={password.label}
              name={password.name}
              value={passwordV}
              placeholder={password.placeholder}
              error={errors.password && touched.password}
              success={passwordV.length > 0 && !errors.password}
              inputProps={{ autoComplete: "" }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={repeatPassword.type}
              label={repeatPassword.label}
              name={repeatPassword.name}
              value={repeatPasswordV}
              placeholder={repeatPassword.placeholder}
              error={errors.repeatPassword && touched.repeatPassword}
              success={repeatPasswordV.length > 0 && !errors.repeatPassword}
              inputProps={{ autoComplete: "" }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default UserInfo;
